export const environment = {
  backendApi: 'https://neurisk-api-staging.tripleai-dev.com'
}
